


export const BreakPoints = {
     Mobile: 767,
    Tablet:1200,
   
}